import { store } from '../store/store';
export const isReportDeviceCheckoutTime = (prevTime: string, currentTime: string) => {
  const reportDeviceCheckoutTime = store.getState()?.organization?.myOrganization?.reportDeviceCheckoutTime;
  return reportDeviceCheckoutTime ? (prevTime ? prevTime : currentTime) : currentTime;
};
